<template>
  <layout :list="listSubs">
    <template #article-list="listSlot">
      <section
        v-for="(section, $index) in listSlot.list"
        :key="`soporte-dash-${$index}`"
        :id="section.slug"
      >
        <h4>{{ section.title }}</h4>
        <ul>
          <li
            v-for="(article, $indexArticle) in section.articles"
            :key="`section-${section.title}-article-${$indexArticle}`"
          >
            <a
              class="color-primary"
              @click="
                $router.push({
                  name: article.path,
                  params: { slug: article.slug }
                })
              "
              >{{ article.title }}</a
            >
          </li>
        </ul>
      </section>
    </template>
  </layout>
</template>

<script>
import Layout from "./Layout";
export default {
  name: "soporteDashboard",
  components: {
    Layout
  },
  data() {
    return {
      list: []
    };
  },
  created() {
    // this.list = this.$store.getters.subModulesList(this.$route.params.id)
  },
  computed: {
    listSubs() {
      return this.$store.getters.actualModuleGetter.submodules;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/general.scss";
</style>
